import React from 'react'
import DeletedCardListContainer from '../DeletedCardListContainer.jsx'
import { useSelector } from 'react-redux'

function DeletedList({ title }) {
    const { user } = useSelector((state) => state.user);

    return (
        <DeletedCardListContainer user={user} matches={user.deleted} title={title} />
    )
}

export default DeletedList